import { Menu } from '@mantine/core';
import { Icon, IconButton } from '@repo/foundations';
import type { FlowActions } from '../../store/LineageFlowUIStore.types';

interface ActionBarMenuProps {
	onExportToPNG: () => void;
	onExpandAllNodes: () => void;
	flowActions: Partial<FlowActions>;
}

function ActionBarMenu({
	onExportToPNG,
	onExpandAllNodes,
	flowActions,
}: ActionBarMenuProps) {
	return (
		<Menu>
			<Menu.Target>
				<IconButton variant="tertiary" iconName="dots" />
			</Menu.Target>
			<Menu.Dropdown>
				<Menu.Item
					icon={<Icon name="arrowsHorizontal" />}
					onClick={onExpandAllNodes}
				>
					Expand all nodes
				</Menu.Item>
				<Menu.Item icon={<Icon name="photo" />} onClick={onExportToPNG}>
					Export PNG
				</Menu.Item>
				{Object.entries(flowActions).map(([key, action]) => (
					<Menu.Item
						key={key}
						icon={<Icon name={action.icon} />}
						onClick={action.onClick}
					>
						{action.label}
					</Menu.Item>
				))}
			</Menu.Dropdown>
		</Menu>
	);
}

export default ActionBarMenu;
